import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=0cb58121&"
var script = {}
import style0 from "./loading.vue?vue&type=style&index=0&id=0cb58121&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports